// removed by extract-text-webpack-plugin
module.exports = {"editable":"editable__3L_JJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Editable/styles.scss
// module id = 2127
// module chunks = 1